import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import {
  FETCH_THANKYOU_FAILURE,
  FETCH_THANKYOU_RESPONSE,
  FETCH_THANKYOU_REQUEST,
  ThankyouActionTypes,
  ThankYouObj
} from '../types/Thankyou';

import { RootState } from '../store/configureStore';
import { getCustomerID, isAuthenticated } from '../helpers/functions';
import history from '../helpers/history';
import c from '../helpers/constants';
import { fetchPaybyLinkThankyou, fetchThankyouDetails } from '../api/ThankyouApi';
import { config } from '../config/config';

export function fetchThankyouRequest(): ThankyouActionTypes {
  return {
    type: FETCH_THANKYOU_REQUEST,
    payload: null,
  };
}

export function fetchThankyouResponse(
  Thankyou: ThankYouObj,
): ThankyouActionTypes {
  return {
    type: FETCH_THANKYOU_RESPONSE,
    payload: Thankyou,
  };
}

export function fetchThankyouFailure(): ThankyouActionTypes {
  return {
    type: FETCH_THANKYOU_FAILURE,
    payload: null,
  };
}



/** Resolves true when assigning window.location (caller should not render). */
export const fetchThankyou = (params: any, page:string):
  ThunkAction<Promise<boolean>, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch(fetchThankyouRequest());
    /* if (!isAuthenticated()) {
       try {
         history.push(c.APP_ROUTES.LOGIN);
       } catch (e) {
       }
     }
       */

    const asyncResp: any = await fetchThankyouDetails(params);

    if (asyncResp) {

      if (asyncResp.data?.origin?.toLowerCase() != config.currentSite && config.currentSite == 'likewise') {

        if (asyncResp.data?.origin?.toLowerCase() == 'delta') {
          window.location.href = 'https://mystifying-lichterman.88-208-226-64.plesk.page/' + page + '?e=' + params.e + '&a=' + params.a + '&t=' + params.t + '&s=' + params.s;
          return true;
        }
        if (asyncResp.data?.origin?.toLowerCase() == 'aa') {
          window.location.href = 'https://aandacarpets.co.uk/'+ page + '?e=' + params.e + '&a=' + params.a + '&t=' + params.t + '&s=' + params.s;
          return true;
        }

        if (asyncResp.data?.origin?.toLowerCase() == 'handv') {
          window.location.href = 'https://clever-gauss.88-208-241-15.plesk.page/'+ page + '?e=' + params.e + '&a=' + params.a + '&t=' + params.t + '&s=' + params.s;
          return true;
        }
        if (asyncResp.data?.origin?.toLowerCase() == 'aanda') {
          window.location.href = 'https://staging.aandacarpets.co.uk/'+ page + 'e=' + params.e + '&a=' + params.a + '&t=' + params.t + '&s=' + params.s;
          return true;
        }
      }
      await dispatch(fetchThankyouResponse(asyncResp));
      return false;
    } else {
      await dispatch(fetchThankyouFailure());
      return false;
    }
  };


/** Resolves true when assigning window.location (caller should not render). */
export const fetchLinkThankyou = (params: any, page:string):
  ThunkAction<Promise<boolean>, RootState, unknown, Action<string>> =>
  async (dispatch) => {
    dispatch(fetchThankyouRequest());

    const asyncResp: any = await fetchPaybyLinkThankyou(params);



    if (asyncResp) {

      if (asyncResp.data?.origin?.toLowerCase() != config.currentSite && config.currentSite == 'likewise') {

        if (asyncResp.data?.origin?.toLowerCase() == 'delta') {
          window.location.href = 'https://mystifying-lichterman.88-208-226-64.plesk.page/' + page + '?e=' + params.e + '&a=' + params.a + '&t=' + params.t + '&s=' + params.s;
          return true;
        }
        if (asyncResp.data?.origin?.toLowerCase() == 'aa') {
          window.location.href = 'https://aandacarpets.co.uk/'+ page + '?e=' + params.e + '&a=' + params.a + '&t=' + params.t + '&s=' + params.s;
          return true;
        }

        if (asyncResp.data?.origin?.toLowerCase() == 'handv') {
          window.location.href = 'https://clever-gauss.88-208-241-15.plesk.page/'+ page + '?e=' + params.e + '&a=' + params.a + '&t=' + params.t + '&s=' + params.s;
          return true;
        }
        if (asyncResp.data?.origin?.toLowerCase() == 'aanda') {
          window.location.href = 'https://staging.aandacarpets.co.uk/'+ page + 'e=' + params.e + '&a=' + params.a + '&t=' + params.t + '&s=' + params.s;
          return true;
        }
      }
      await dispatch(fetchThankyouResponse(asyncResp));
      return false;
    } else {
      await dispatch(fetchThankyouFailure());
      return false;
    }
  };